var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 2.75H2.75C2.35218 2.75 1.97064 2.90804 1.68934 3.18934C1.40804 3.47064 1.25 3.85218 1.25 4.25V13.25C1.25 13.6478 1.40804 14.0294 1.68934 14.3107C1.97064 14.592 2.35218 14.75 2.75 14.75H10.25C10.6478 14.75 11.0294 14.592 11.3107 14.3107C11.592 14.0294 11.75 13.6478 11.75 13.25V4.25C11.75 3.85218 11.592 3.47064 11.3107 3.18934C11.0294 2.90804 10.6478 2.75 10.25 2.75H8.75",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.25H6.125C5.82663 7.25 5.54048 7.36853 5.3295 7.5795C5.11853 7.79048 5 8.07663 5 8.375C5 8.67337 5.11853 8.95952 5.3295 9.1705C5.54048 9.38147 5.82663 9.5 6.125 9.5H6.875C7.17337 9.5 7.45952 9.61853 7.6705 9.8295C7.88147 10.0405 8 10.3266 8 10.625C8 10.9234 7.88147 11.2095 7.6705 11.4205C7.45952 11.6315 7.17337 11.75 6.875 11.75H5M6.5 11.75V12.5M6.5 6.5V7.25M4.25 2.75C4.25 2.35218 4.40804 1.97064 4.68934 1.68934C4.97064 1.40804 5.35218 1.25 5.75 1.25H7.25C7.64782 1.25 8.02936 1.40804 8.31066 1.68934C8.59196 1.97064 8.75 2.35218 8.75 2.75C8.75 3.14782 8.59196 3.52936 8.31066 3.81066C8.02936 4.09196 7.64782 4.25 7.25 4.25H5.75C5.35218 4.25 4.97064 4.09196 4.68934 3.81066C4.40804 3.52936 4.25 3.14782 4.25 2.75Z",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListMoney);
export default __webpack_public_path__ + "static/media/list-money.bf519fbe.svg";
export { ForwardRef as ReactComponent };